import React, { useEffect, useRef, useState, forwardRef } from "react";
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "react-intl-tel-input/dist/main.css";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import {
  AdditionalInfoWantToGrowInterfaceNEW,
  ProductsDescriptionWantToGrow,
  RegistrationIds,
} from "../../../../assets/interface/primeSharkWebsite_interface";
import HelperService from "../../../../Services/HelperService";
import WebService from "../../../../Services/WebService";
import { Label } from "../../../Common/Label/Label";
import CommonScrollbar from "../../../Common/ScrollBar/CommonScrollbar";
import CompoLoader from "../../../ComponentLoader/CompoLoader";
import Select from "react-dropdown-select";
import ErrorComponent from "../../../Common/ErrorComponent";
import {
  ACCOUNT_TYPE_API,
  DROPDOWNTYPES,
} from "../../../../assets/constants/constants";
import {
  dropdownApiNewcall,
  getProfileJourneyInfo,
} from "../../../../Services/CommonFunction";
import RequiredLabel from "../../../Common/RequiredLabel/RequiredLabel";
import Select1 from "react-select";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import { FaPlus, FaUpload } from "react-icons/fa6";
import { AiOutlineClose } from "react-icons/ai";
import CommonModal from "../../../Common/CommonModal";
import InfoIconForKeyword from "../../../Common/info/infoIcon";
import { isWarning } from "../../Helper";
import { useDispatch } from "react-redux";


interface PropsData {
  handleNext: any;
  impIds: RegistrationIds;
  from?: string;
  fields_to_improve?: any;
}
const types = [
  DROPDOWNTYPES.BUSINESS_INDUSTRY,
  DROPDOWNTYPES.INDUSTRY_SECTOR,
  DROPDOWNTYPES.BUSINESS_MODEL,
  DROPDOWNTYPES.NO_OF_EMPLOYEES,
  DROPDOWNTYPES.PREFERRED_TRADE_TERM,
  DROPDOWNTYPES.PROFILE_VISIBILITY,
  DROPDOWNTYPES.LOOKING_FOR_CONNECT,
  DROPDOWNTYPES.PURPOSE_OF_NETWORKING,
  DROPDOWNTYPES.TYPE_OF_COLLABORATION,
  DROPDOWNTYPES.PREFERRED_TRADE_TERM,
  DROPDOWNTYPES.OPERATIONAL_REGION,
];
const PREFERRED_COMMUNICATION_MODES = [
  { title: "Email" },
  { title: "Chat" },
  { title: "Video Meet" },
  { title: "On-ground Meeting" },
];

const CustomYearInput = forwardRef(({ value, onClick }: any, ref: any) => (
  <div className="input-group w-100" onClick={onClick} ref={ref} style={{ cursor: "pointer" }}>
    <input
      type="text"
      className="form-control"
      value={value}
      readOnly
      placeholder="Select year"
    />
    <span className="input-group-text bg-white">
      <FaCalendarAlt />
    </span>
  </div>
));

const AdditionalInfoWantToGrow = ({
  handleNext,
  impIds,
  from,
  fields_to_improve,
}: PropsData) => {
  const { t } = useTranslation();
  let dispatch = useDispatch();
  const [errorFlag, setErrorFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const [dropdownData, setDropdownData] = useState<Record<string, any[]>>({});
  const MAX_PRODUCTS = 3;
  const [modalImage, setModalImage] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [imageLaoder, setImageLoader] = useState<any>([]);

  const controlRef = useRef<HTMLDivElement | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuOpen4, setMenuOpen4] = useState(false);
  const controlRef5 = useRef<HTMLDivElement | null>(null);
  const [menuOpen5, setMenuOpen5] = useState(false);

  const controlRef6 = useRef<HTMLDivElement | null>(null);
  const [menuOpen6, setMenuOpen6] = useState(false);
  useEffect(() => {
    if (!menuOpen) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          setMenuOpen(false);
        }
      },
      {
        root: null, // viewport
        threshold: 0, // even 1px visibility counts
      },
    );

    if (controlRef.current) {
      observer.observe(controlRef.current);
    }

    return () => observer.disconnect();
  }, [menuOpen]);

  const controlRef1 = useRef<HTMLDivElement | null>(null);
  const [menuOpen1, setMenuOpen1] = useState(false);
  const [skipButtonClicked, setSkipButtonClicked] = useState(false);
  const [apiCallTriggered, setAPICallTriggered] = useState(false);

  useEffect(() => {
    if (!menuOpen1) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          setMenuOpen1(false);
        }
      },
      {
        root: null, // viewport
        threshold: 0, // even 1px visibility counts
      },
    );

    if (controlRef1.current) {
      observer.observe(controlRef1.current);
    }

    return () => observer.disconnect();
  }, [menuOpen1]);

  const [additionalInfo, setAdditionalInfo] =
    useState<AdditionalInfoWantToGrowInterfaceNEW>({
      industry_sector: "",
      business_models: [],
      no_of_employee: "",
      year_of_establishment: "",
      brief_about_business: "",
      looking_for_connect: [],
      seeking_any_solution_partner: "",
      solution_requirement: "",
      geographies_investments: [],
      preferred_trade_term: "",
      preferred_trade_term_other: "",
      purpose_of_networking_other: "",
      preferred_communication_mode: [],
      profile_visibility: "",
      top_keywords: [],
      products: [
        { title: "", description: "", category: "", image: "", image_url: "" },
      ],
      type_of_collaboration: "",
      purpose_of_networking: "",
      industry_sector_other: "",
      type_of_collaboration_other: "",
    });

  useEffect(() => {
    if (impIds?.uuid) {
      getAdditionalDetails();
    }
    loadDropdowns();
  }, []);

  async function loadDropdowns() {
    try {
      const res = await dropdownApiNewcall("want-to-grow", types);
      const formattedData: Record<string, any[]> = {};

      types.forEach((type) => {
        const items = res[type];

        if (Array.isArray(items)) {
          if (
            type === "industry_sector" ||
            type === "preferred_trade_term" ||
            type === "type_of_collaboration"
          ) {
            const grouped = items.reduce((acc: Record<string, any[]>, item) => {
              const groupName = item.group || "Other";
              if (!acc[groupName]) acc[groupName] = [];
              acc[groupName].push({
                label: item.title,
                value: item?.is_other === 1 ? "Other" : item.title,
              });
              return acc;
            }, {});

            formattedData[type] = Object.entries(grouped).map(
              ([group, options]) => ({
                label: group,
                options,
              }),
            );
          } else {
            formattedData[type] = items.map((item) => ({
              label: item.title,
              value: item.title,
            }));
          }
        }
      });

      setDropdownData(formattedData);
    } catch (error) { }
  }

  const handleProductChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = event.target;

    const updatedProducts = [...additionalInfo.products];
    updatedProducts[index] = {
      ...updatedProducts[index],
      [name]: value,
    };

    setAdditionalInfo({
      ...additionalInfo,
      products: updatedProducts,
    });
  };

  const getAdditionalDetails = () => {
    setLoader(true);
    return WebService.getAPI({
      action: `get-business/want-to-grow/${impIds?.business_uuid}`,
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          let info = res?.info;
          const industryVal =
            (Array.isArray(info?.business_industry) && info?.business_industry.length > 0
              ? info?.business_industry[0]?.title || info?.business_industry[0]?.name || info?.business_industry[0]
              : typeof info?.business_industry === "string"
                ? info?.business_industry
                : null) ||
            (Array.isArray(info?.industry) && info?.industry.length > 0
              ? info?.industry[0]?.title || info?.industry[0]?.name || info?.industry[0]
              : typeof info?.industry === "string"
                ? info?.industry
                : null) ||
            info?.industry_sector ||
            "";

          setAdditionalInfo(
            (prevDetails: AdditionalInfoWantToGrowInterfaceNEW) => ({
              ...prevDetails,
              industry_sector: industryVal,
              business_models: info?.business_models ?? [],
              no_of_employee: info?.no_of_employee,
              year_of_establishment: info?.year_of_establishment,
              brief_about_business: info?.brief_about_business,
              looking_for_connect: info?.looking_for_connect,
              seeking_any_solution_partner:
                info?.seeking_any_solution_partner === 1 ? "1" : "0",
              solution_requirement: info?.solution_requirement,
              geographies_investments: info?.geographies_investments ?? [],
              preferred_trade_term: info?.preferred_trade_term ?? "",
              preferred_trade_term_other:
                info?.preferred_trade_term_other ?? "",
              type_of_collaboration_other:
                info?.type_of_collaboration_other ?? "",
              preferred_communication_mode: info?.preferred_communication_mode,
              profile_visibility: info?.profile_visibility,
              top_keywords: info?.top_keywords,
              products:
                info?.products?.length > 0
                  ? info?.products
                  : [
                    {
                      title: "",
                      description: "",
                      category: "",
                      image: "",
                      image_url: "",
                    },
                  ],
              type_of_collaboration: info?.type_of_collaboration,
              purpose_of_networking: info?.purpose_of_networking,
              industry_sector_other: info?.industry_sector_other,
              purpose_of_networking_other: info?.purpose_of_networking_other,
            }),
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "brief_about_business" && value.length > 700) return;
    setAdditionalInfo(
      (prevBasicDetails: AdditionalInfoWantToGrowInterfaceNEW) => ({
        ...prevBasicDetails,
        [name]: value,
      }),
    );
  };
  const isProductStarted = (p: any) => {
    if (!p) return false;
    return !!(
      p?.title?.trim() ||
      p?.description?.trim() ||
      p?.category?.trim() ||
      p?.image ||
      p?.image_url
    );
  };

  const isProductComplete = (p: any) => {
    if (!p) return false;
    const hasTitle = !!p?.title?.trim();
    const hasCategory = !!p?.category?.trim();
    const hasImage = !!(p?.image || p?.image_url);
    return hasTitle && hasCategory && hasImage;
  };

  const handleSaveAdditionInfo = (flag: boolean) => {
    const hasIncompleteProduct = additionalInfo?.products?.some(
      (p) => isProductStarted(p) && !isProductComplete(p),
    );

    if (
      HelperService?.checkFormEmptyFields(additionalInfo, [
        "login_type",
        "solution_requirement",
        "preferred_trade_term",
        "industry_sector_other",
        "purpose_of_networking_other",
        "type_of_collaboration_other",
        "preferred_trade_term_other",
        "business_models",
        "no_of_employee",
        "year_of_establishment",
        "brief_about_business",
        "looking_for_connect",
        "seeking_any_solution_partner",
        "purpose_of_networking",
        "top_keywords",
        "type_of_collaboration",
        "profile_visibility",
      ]) ||
      additionalInfo?.looking_for_connect?.some(
        (item) =>
          item?.title === "Other" &&
          (!item?.other || item?.other?.trim() === ""),
      ) ||
      (additionalInfo?.industry_sector?.toLowerCase() === "other" &&
        !additionalInfo?.industry_sector_other) ||
      (additionalInfo?.purpose_of_networking?.toLowerCase() === "other" &&
        !additionalInfo?.purpose_of_networking_other) ||
      (additionalInfo?.preferred_trade_term?.toLowerCase() === "other" &&
        !additionalInfo?.preferred_trade_term_other) ||
      (additionalInfo?.type_of_collaboration?.toLowerCase() === "other" &&
        !additionalInfo?.type_of_collaboration_other)
    ) {
      setErrorFlag(true);
      return;
    } else if (hasIncompleteProduct) {
      setErrorFlag(true);
      return;
    } else if (
      additionalInfo?.seeking_any_solution_partner === "1" &&
      !additionalInfo?.solution_requirement
    ) {
      setErrorFlag(true);
      return;
    } else {
      setErrorFlag(false);
    }
    if (impIds?.business_uuid) {
      handleUpdateBasicDetailsApiCall(flag);
    }
  };

  const handleUpdateBasicDetailsApiCall = (flag: boolean) => {
    if (flag) WebService.addLoader("skip_basic_details");
    else WebService.addLoader("save_basic_details");
    setAPICallTriggered(true);
    const validProducts = additionalInfo.products.filter((p) =>
      isProductStarted(p),
    );
    const payload = {
      ...additionalInfo,
      products: validProducts,
      industry_sector: additionalInfo.industry_sector,
      business_industry: additionalInfo.industry_sector
        ? [
          {
            title: additionalInfo.industry_sector,
            other:
              additionalInfo.industry_sector === "Other"
                ? additionalInfo.industry_sector_other
                : null,
          },
        ]
        : [],
    };
    return WebService.putAPI({
      action: `set-business/${ACCOUNT_TYPE_API.WANT_TO_GROW}/${impIds?.business_uuid}`,
      body: payload,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          toast.success(res.message);
          if (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") {
            getProfileJourneyInfo(
              impIds?.account_type?.toLocaleLowerCase(),
              impIds?.business_uuid,
              dispatch,
            );
          }
          handleNext(res);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);

        return error;
      })
      .finally(() => {
        if (flag) WebService.removeLoader("skip_basic_details");
        else WebService.removeLoader("save_basic_details");
        setAPICallTriggered(false);
      });
  };
  const handleArrayValueChange = (value: any[], key: string) => {
    setAdditionalInfo((prevDetails: AdditionalInfoWantToGrowInterfaceNEW) => ({
      ...prevDetails,
      [key]: Array.isArray(
        prevDetails[key as keyof AdditionalInfoWantToGrowInterfaceNEW],
      )
        ? value.map((item) => ({ title: item?.value }))
        : value[0]?.value,
    }));
  };
  const handleAdd = () => {
    if (additionalInfo.products.length < MAX_PRODUCTS) {
      setAdditionalInfo({
        ...additionalInfo,
        products: [
          ...additionalInfo.products,
          {
            title: "",
            description: "",
            category: "",
            image: "",
            image_url: "",
          },
        ],
      });
    }
  };

  const handleDelete = (index: number) => {
    if (additionalInfo.products.length === 1) {
      setAdditionalInfo({
        ...additionalInfo,
        products: [
          {
            title: "",
            description: "",
            category: "",
            image: "",
            image_url: "",
          },
        ],
      });
      return;
    }
    const updatedProducts = additionalInfo.products.filter(
      (_, i) => i !== index,
    );
    setAdditionalInfo({
      ...additionalInfo,
      products: updatedProducts,
    });
  };
  const uploadFile = (event: any, index: number) => {
    const selectedFiles = event.target.files;
    const file = selectedFiles?.length > 0 && selectedFiles[0];

    if (file?.size > 10 * 1024 * 1024) {
      toast.error("Maximum file size 10 mb");
      return;
    }
    if (file) {
      handleUploadFile(file, index);
      event.target.value = null;
    }
  };
  async function handleUploadFile(file: any, index: number) {
    setImageLoader((prev: any) => {
      const newLoaders = [...prev];
      newLoaders[index] = true;
      return newLoaders;
    });
    const previewUrl = URL.createObjectURL(file);
    await WebService.uploadAPI({
      action: `upload/product-image`,
      _file: file,
      key: "file",
    })
      .then((res: any) => {
        if (res?.status) {
          setAdditionalInfo((prev) => {
            const updatedProducts = [...prev.products];
            updatedProducts[index] = {
              ...updatedProducts[index],
              image: res?.name,
              image_url: previewUrl,
            };
            return { ...prev, products: updatedProducts };
          });
        }
        toast.success(res?.message);
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        setImageLoader((prev: any) => {
          const newLoaders = [...prev];
          newLoaders[index] = false;
          return newLoaders;
        });
      });
  }
  const handleImageView = (imageUrl: string, title: string) => {
    setModalTitle(title);
    setModalImage(imageUrl);
    setShowModal(true);
  };
  return (<>
    <div className="login-form w-100 px-0 position-relative">
      {loader ? <CompoLoader /> : null}
      <div className="custom-title my-auto font-bold mb-2 ">
        Additional Information
      </div>

      <CommonScrollbar height={from === "REVIEW" ? "auto" : "65vh"}>
        <div className="me-3">
          <div className="mb-2 w-100">
            <RequiredLabel isRequired={true}>Business Industry</RequiredLabel>
            <div ref={controlRef}>
              <Select1
                classNamePrefix="react-select"
                menuPortalTarget={document.body}
                className={
                  (!additionalInfo?.business_industry && skipButtonClicked) ||
                    isWarning(fields_to_improve, "business_industry")
                    ? "warning-field"
                    : ""
                }
                menuIsOpen={menuOpen}
                onMenuOpen={() => setMenuOpen(true)}
                onMenuClose={() => setMenuOpen(false)}
                closeMenuOnScroll={false}
                menuShouldScrollIntoView={false}
                menuPosition="fixed"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                  control: (base) => ({
                    ...base,
                    minHeight: "45px",
                    height: "45px",
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "45px",
                    padding: "0 8px",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: "0px",
                    padding: "0px",
                  }),
                  indicatorsContainer: (base) => ({
                    ...base,
                    height: "45px",
                  }),
                  menuList: (base) => ({
                    ...base,
                    maxHeight: "300px",
                    padding: "0",
                  }),
                }}
                options={
                  (dropdownData[DROPDOWNTYPES.BUSINESS_INDUSTRY]?.length
                    ? dropdownData[DROPDOWNTYPES.BUSINESS_INDUSTRY]
                    : dropdownData[DROPDOWNTYPES.INDUSTRY_SECTOR]) || []
                }
                name="industry_sector"
                placeholder="Select Business Industry"
                value={
                  additionalInfo?.industry_sector
                    ? [
                      {
                        value: additionalInfo?.industry_sector,
                        label: additionalInfo?.industry_sector,
                      },
                    ]
                    : []
                }
                onChange={(values) => {
                  handleArrayValueChange([values], "industry_sector");
                }}
              />
            </div>
            {additionalInfo?.industry_sector === "Other" && (
              <div className="w-100 mt-2">
                <RequiredLabel isRequired={true}>
                  Other Business Industry
                </RequiredLabel>
                <Form.Control
                  type="text"
                  // name="choose_profile_other"
                  placeholder="Other business industry"
                  onChange={(e) => {
                    const value = e.target.value;
                    setAdditionalInfo((prev) => ({
                      ...prev,
                      industry_sector_other: value,
                    }));
                  }}
                  value={additionalInfo?.industry_sector_other}
                />
                {errorFlag &&
                  additionalInfo?.industry_sector === "Other" &&
                  !additionalInfo?.industry_sector_other && (
                    <Label
                      title="Please enter other business industry"
                      modeError={true}
                    />
                  )}
              </div>
            )}

            <ErrorComponent
              title="Please select business industry"
              flag={errorFlag && !skipButtonClicked}
              isArray={false}
              data={additionalInfo?.industry_sector}
            />
          </div>
          <div className="mb-2 w-100 mt-2">
            <RequiredLabel isRequired={false} infoMultiple>
              Business Model(max 3)
            </RequiredLabel>
            <Select1
              classNamePrefix="react-select"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 999999 }),
              }}
              className={
                isWarning(fields_to_improve, "business_model")
                  ? "warning-field"
                  : ""
              }
              isMulti
              menuPortalTarget={document.body}
              menuIsOpen={menuOpen4}
              onMenuOpen={() => setMenuOpen4(true)}
              onMenuClose={() => setMenuOpen4(false)}
              closeMenuOnScroll={false}
              menuPosition="fixed"
              options={dropdownData[DROPDOWNTYPES.BUSINESS_MODEL] || []}
              onChange={(values: any) => {
                if (values?.length > 3) {
                  toast.warn("You can select a maximum of 3 options.");
                  return false;
                } else handleArrayValueChange(values || [], "business_models");
              }}
              name="business_models"
              value={
                additionalInfo?.business_models?.length > 0
                  ? additionalInfo?.business_models.map((item: any) => ({
                    value: item?.title,
                    label: item?.title,
                  }))
                  : []
              }
            />

            {/* <ErrorComponent
              title="Please select business model"
              flag={errorFlag}
              isArray={true}
              data={additionalInfo?.business_models}
            /> */}
          </div>
          <div className="mb-2 d-flex w-100 gap-1">
            <div className="mb-2 w-50 ">
              <RequiredLabel isRequired={false}>
                Number Of Employees
              </RequiredLabel>
              <Select
                options={dropdownData[DROPDOWNTYPES.NO_OF_EMPLOYEES] || []}
                onChange={(values: any) => {
                  if (values?.length > 0) {
                    handleArrayValueChange(values, "no_of_employee");
                  }
                }}
                labelField="label"
                valueField="value"
                name="no_of_employee"
                className={
                  isWarning(fields_to_improve, "no_of_employees")
                    ? "warning-field"
                    : ""
                }
                values={
                  additionalInfo?.no_of_employee
                    ? [
                      {
                        value: additionalInfo?.no_of_employee,
                        label: additionalInfo?.no_of_employee,
                      },
                    ]
                    : []
                }
              />
              {/* <ErrorComponent
                title="Please select no of employee"
                flag={errorFlag}
                isArray={true}
                data={additionalInfo?.no_of_employee}
              /> */}
            </div>

            <div className="w-50">
              <RequiredLabel isRequired={false}>
                Year Of Establishment
              </RequiredLabel>

              <DatePicker
                selected={
                  additionalInfo?.year_of_establishment
                    ? new Date(`${additionalInfo?.year_of_establishment}-01-01`)
                    : null
                }
                wrapperClassName="w-100"
                onChange={(date: Date | null) => {
                  if (date) {
                    setAdditionalInfo((prev: any) => ({
                      ...prev,
                      year_of_establishment: date.getFullYear().toString(),
                    }));
                  } else {
                    setAdditionalInfo((prev: any) => ({
                      ...prev,
                      year_of_establishment: "",
                    }));
                  }
                }}
                showYearPicker
                dateFormat="yyyy"
                minDate={new Date("1900-01-01")}
                maxDate={new Date()}
                className={
                  isWarning(fields_to_improve, "year_of_establishment")
                    ? "warning-field form-control w-100"
                    : "form-control w-100"
                }
                placeholderText="Select year"
                customInput={<CustomYearInput />}
              />
            </div>
          </div>
          <div className="mb-2 w-100 ">
            <RequiredLabel isRequired={false} infoMultiple={true}>
              Looking to Connect With(max 3)
            </RequiredLabel>
            <div ref={controlRef1}>
              <Select1
                classNamePrefix="react-select"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                }}
                menuPortalTarget={document.body}
                menuIsOpen={menuOpen1}
                onMenuOpen={() => setMenuOpen1(true)}
                onMenuClose={() => setMenuOpen1(false)}
                closeMenuOnScroll={false}
                menuPosition="fixed"
                options={dropdownData[DROPDOWNTYPES.LOOKING_FOR_CONNECT] || []}
                isMulti
                className={
                  isWarning(fields_to_improve, "looking_for_connect")
                    ? "warning-field"
                    : ""
                }
                menuPlacement="bottom"
                onChange={(values: any) => {
                  if (values?.length > 3) {
                    toast.warn("You can select a maximum of 3 options.");
                    return false;
                  } else handleArrayValueChange(values, "looking_for_connect");
                }}
                name="looking_for_connect"
                value={
                  additionalInfo?.looking_for_connect?.length > 0
                    ? additionalInfo?.looking_for_connect.map((item: any) => ({
                      value: item?.title,
                      label: item?.title,
                    }))
                    : []
                }
              />
            </div>
            {/* <ErrorComponent
              title="Please select looking to connect with"
              flag={errorFlag}
              isArray={true}
              data={additionalInfo?.looking_for_connect}
            /> */}
          </div>
          {additionalInfo?.looking_for_connect?.some(
            (item) => item?.title === "Other",
          ) && (
              <div className="w-100 mt-2">
                <RequiredLabel isRequired={true}>
                  Other looking to connect with
                </RequiredLabel>
                <Form.Control
                  type="text"
                  // name="choose_profile_other"
                  placeholder="Enter other interested in option"
                  onChange={(e) => {
                    const value = e.target.value;
                    setAdditionalInfo((prev) => ({
                      ...prev,
                      looking_for_connect: prev.looking_for_connect?.map(
                        (item: any) =>
                          item.title === "Other"
                            ? { ...item, other: value }
                            : item,
                      ),
                    }));
                  }}
                  value={
                    additionalInfo?.looking_for_connect?.find(
                      (item) => item.title === "Other",
                    )?.other ?? ""
                  }
                  className={
                    isWarning(fields_to_improve, "looking_for_connect")
                      ? "warning-field"
                      : ""
                  }
                />
                {errorFlag &&
                  additionalInfo?.looking_for_connect?.some(
                    (item) =>
                      item?.title === "Other" &&
                      (!item?.other || item?.other?.trim() === ""),
                  ) && (
                    <Label
                      title="Please enter other looking for connect with"
                      modeError={true}
                    />
                  )}
              </div>
            )}
          {/* <div className="mb-2 w-100">
            <RequiredLabel isRequired={true}>
              Preferred Geographies for Collaboration
            </RequiredLabel>

            <Form.Control
              type="text"
              name="geographies_investment"
              placeholder="Enter geographies"
              onChange={handleChange}
              value={additionalInfo?.geographies_investment}
            />
            <ErrorComponent
              title="Please enter geographies for collaboration"
              flag={errorFlag}
              isArray={false}
              data={additionalInfo?.geographies_investment}
            />
          </div> */}

          <div className="mb-1 w-100 ">
            <RequiredLabel isRequired={true}>
              Preferred Geographies for Collaboration(max 3)
            </RequiredLabel>

            <Select1
              classNamePrefix="react-select"
              menuPosition="fixed"
              options={dropdownData[DROPDOWNTYPES.OPERATIONAL_REGION] || []}
              isMulti
              className={
                (additionalInfo?.geographies_investments?.length === 0 &&
                  skipButtonClicked) ||
                  isWarning(fields_to_improve, "geographies_investments")
                  ? "warning-field"
                  : ""
              }
              menuPlacement="bottom"
              onChange={(values: any) => {
                if (values?.length > 3) {
                  toast.warn("You can select a maximum of 3 options.");
                  return false;
                } else
                  handleArrayValueChange(values, "geographies_investments");
              }}
              name="geographies_investments"
              value={
                additionalInfo?.geographies_investments?.length > 0
                  ? additionalInfo?.geographies_investments?.map(
                    (item: any) => ({
                      value: item?.title,
                      label: item?.title,
                    }),
                  )
                  : []
              }
            />

            <ErrorComponent
              title="Please select operational region"
              flag={errorFlag && !skipButtonClicked}
              isArray={true}
              data={additionalInfo?.geographies_investments}
            />
          </div>
          <div className="mb-2 w-100">
            <RequiredLabel isRequired={false}>
              Preferred Trade Term
            </RequiredLabel>
            <div ref={controlRef6}>
              <Select1
                classNamePrefix="react-select"
                menuPortalTarget={document.body}
                className={
                  isWarning(fields_to_improve, "preferred_trade_term")
                    ? "warning-field"
                    : ""
                }
                menuIsOpen={menuOpen6}
                onMenuOpen={() => setMenuOpen6(true)}
                onMenuClose={() => setMenuOpen6(false)}
                closeMenuOnScroll={false}
                menuShouldScrollIntoView={false}
                menuPosition="fixed"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                  control: (base) => ({
                    ...base,
                    minHeight: "45px",
                    height: "45px",
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "45px",
                    padding: "0 8px",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: "0px",
                    padding: "0px",
                  }),
                  indicatorsContainer: (base) => ({
                    ...base,
                    height: "45px",
                  }),
                  menuList: (base) => ({
                    ...base,
                    maxHeight: "300px",
                    padding: "0",
                  }),
                }}
                options={dropdownData[DROPDOWNTYPES.PREFERRED_TRADE_TERM] || []} // keep grouped structure
                name="preferred_trade_term"
                value={
                  additionalInfo?.preferred_trade_term
                    ? [
                      {
                        value: additionalInfo?.preferred_trade_term,
                        label: additionalInfo?.preferred_trade_term,
                      },
                    ]
                    : []
                }
                onChange={(values) => {
                  handleArrayValueChange([values], "preferred_trade_term");
                }}
              />
            </div>
            {/* <Select
              className=""
              options={dropdownData[DROPDOWNTYPES.PREFERRED_TRADE_TERM] || []}
              onChange={(values: any) => {
                if (values?.length > 0) {console.log(values);
                
                  handleArrayValueChange(values, "preferred_trade_term");
                }
              }}
              labelField="label"
              valueField="value"
              name="preferred_trade_term"
              placeholder="Select"
              values={
                additionalInfo?.preferred_trade_term
                  ? [
                      {
                        value: additionalInfo?.preferred_trade_term,
                        label: additionalInfo?.preferred_trade_term,
                      },
                    ]
                  : []
              }
            /> */}
            {/* <ErrorComponent
              title="Please select business model"
              flag={errorFlag}
              isArray={true}
              data={additionalInfo?.business_models}
            /> */}
          </div>
          {additionalInfo?.preferred_trade_term === "Other" && (
            <div className="w-100 mt-2">
              <RequiredLabel isRequired={true}>
                Other Preferred Trade Term
              </RequiredLabel>
              <Form.Control
                type="text"
                // name="choose_profile_other"
                placeholder="Enter other preferred trade term "
                onChange={(e) => {
                  const value = e.target.value;
                  setAdditionalInfo((prev) => ({
                    ...prev,
                    preferred_trade_term_other: value,
                  }));
                }}
                value={additionalInfo?.preferred_trade_term_other}
                className={
                  isWarning(fields_to_improve, "preferred_trade_term_other")
                    ? "warning-field"
                    : ""
                }
              />
              {errorFlag &&
                additionalInfo?.preferred_trade_term === "Other" &&
                !additionalInfo?.preferred_trade_term_other && (
                  <Label
                    title="Please enter other preferred trade term"
                    modeError={true}
                  />
                )}
            </div>
          )}

          <div className="mb-2 w-100">
            <RequiredLabel isRequired={false}>
              How Visible Should Your Profile Be?
            </RequiredLabel>
            <Select
              className={
                isWarning(fields_to_improve, "preferred_trade_term_other")
                  ? "warning-field"
                  : ""
              }
              options={dropdownData[DROPDOWNTYPES.PROFILE_VISIBILITY] || []}
              onChange={(values: any) => {
                if (values?.length > 0) {
                  handleArrayValueChange(values, "profile_visibility");
                }
              }}
              labelField="label"
              valueField="value"
              name="profile_visibility"
              values={
                additionalInfo?.profile_visibility
                  ? [
                    {
                      value: additionalInfo?.profile_visibility,
                      label: additionalInfo?.profile_visibility,
                    },
                  ]
                  : []
              }
            />
            {/* <ErrorComponent
              title="Please select profile visibility"
              flag={errorFlag}
              isArray={true}
              data={additionalInfo?.profile_visibility}
            /> */}
          </div>
          <div className="mb-2 w-100">
            <RequiredLabel isRequired={false}>
              Type of Collaboration
            </RequiredLabel>
            <div ref={controlRef5}>
              <Select1
                classNamePrefix="react-select"
                className={
                  isWarning(fields_to_improve, "type_of_collaboration")
                    ? "warning-field"
                    : ""
                }
                menuPortalTarget={document.body}
                menuIsOpen={menuOpen5}
                onMenuOpen={() => setMenuOpen5(true)}
                onMenuClose={() => setMenuOpen5(false)}
                closeMenuOnScroll={false}
                menuShouldScrollIntoView={false}
                menuPosition="fixed"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                  control: (base) => ({
                    ...base,
                    minHeight: "45px",
                    height: "45px",
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "45px",
                    padding: "0 8px",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: "0px",
                    padding: "0px",
                  }),
                  indicatorsContainer: (base) => ({
                    ...base,
                    height: "45px",
                  }),
                  menuList: (base) => ({
                    ...base,
                    maxHeight: "300px",
                    padding: "0",
                  }),
                }}
                options={
                  dropdownData[DROPDOWNTYPES.TYPE_OF_COLLABORATION] || []
                } // keep grouped structure
                name="industry_sector"
                value={
                  additionalInfo?.type_of_collaboration
                    ? [
                      {
                        value: additionalInfo?.type_of_collaboration,
                        label: additionalInfo?.type_of_collaboration,
                      },
                    ]
                    : []
                }
                onChange={(values) => {
                  handleArrayValueChange([values], "type_of_collaboration");
                }}
              />
            </div>
            {additionalInfo?.type_of_collaboration === "Other" && (
              <div className="w-100 mt-2 mb-2">
                <RequiredLabel isRequired={true}>
                  Other Type Of Collaboration
                </RequiredLabel>
                <Form.Control
                  type="text"
                  // name="choose_profile_other"
                  placeholder="Other type of collaboration"
                  onChange={(e) => {
                    const value = e.target.value;
                    setAdditionalInfo((prev) => ({
                      ...prev,
                      type_of_collaboration_other: value,
                    }));
                  }}
                  className={
                    isWarning(fields_to_improve, "type_of_collaboration_other")
                      ? "warning-field"
                      : ""
                  }
                  value={additionalInfo?.type_of_collaboration_other}
                />
                {/* {errorFlag &&
                  additionalInfo?.type_of_collaboration === "Other" &&
                  !additionalInfo?.type_of_collaboration_other && (
                    <Label
                      title="Please enter other type of collaboration"
                      modeError={true}
                    />
                  )} */}
              </div>
            )}

            {/* <ErrorComponent
              title="Please select type of collaboration"
              flag={errorFlag}
              isArray={true}
              data={additionalInfo?.type_of_collaboration}
            /> */}

            <div className="mb-2 w-100">
              <RequiredLabel isRequired={false}>
                Purpose of Networking
              </RequiredLabel>
              <Select
                className={
                  isWarning(fields_to_improve, "purpose_of_networking")
                    ? "warning-field"
                    : ""
                }
                options={
                  dropdownData[DROPDOWNTYPES.PURPOSE_OF_NETWORKING] || []
                }
                onChange={(values: any) => {
                  if (values?.length > 0) {
                    handleArrayValueChange(values, "purpose_of_networking");
                  }
                }}
                labelField="label"
                valueField="value"
                name="purpose_of_networking"
                values={
                  additionalInfo?.purpose_of_networking
                    ? [
                      {
                        value: additionalInfo?.purpose_of_networking,
                        label: additionalInfo?.purpose_of_networking,
                      },
                    ]
                    : []
                }
              />
              {/* <ErrorComponent
                title="Please select purpose of networking"
                flag={errorFlag}
                isArray={true}
                data={additionalInfo?.purpose_of_networking}
              /> */}
            </div>
            {additionalInfo?.purpose_of_networking === "Other" && (
              <div className="w-100 mt-2">
                <RequiredLabel isRequired={true}>
                  Other Purpose Of Networking
                </RequiredLabel>
                <Form.Control
                  type="text"
                  placeholder="Other purpose of networking"
                  onChange={(e) => {
                    const value = e.target.value;
                    setAdditionalInfo((prev) => ({
                      ...prev,
                      purpose_of_networking_other: value,
                    }));
                  }}
                  value={additionalInfo?.purpose_of_networking_other}
                  className={
                    isWarning(fields_to_improve, "purpose_of_networking_other")
                      ? "warning-field"
                      : ""
                  }
                />
                {errorFlag &&
                  additionalInfo?.purpose_of_networking === "Other" &&
                  !additionalInfo?.purpose_of_networking_other && (
                    <Label
                      title="Please enter other purpose of networking"
                      modeError={true}
                    />
                  )}
              </div>
            )}
            <div className="mb-2">
              <RequiredLabel isRequired={false}>
                Preferred Communication Mode
              </RequiredLabel>

              <div className="d-flex gap-3 mt-1 flex-wrap">
                {PREFERRED_COMMUNICATION_MODES.map((item, index) => (
                  <div
                    className={` ${isWarning(
                      fields_to_improve,
                      "preferred_communication_mode",
                    )
                      ? "active-warning communication-pill"
                      : ""
                      }`}
                    key={index}
                  >
                    <input
                      // className="communication-checkbox"
                      type="checkbox"
                      id={`index_${index}`}
                      checked={additionalInfo?.preferred_communication_mode?.some(
                        (mode) => mode.title === item.title,
                      )}
                      onChange={(e) => {
                        const checked = e.target.checked;

                        setAdditionalInfo((prev) => {
                          const currentModes =
                            prev.preferred_communication_mode || [];

                          return {
                            ...prev,
                            preferred_communication_mode: checked
                              ? [...currentModes, item]
                              : currentModes.filter(
                                (mode) => mode.title !== item.title,
                              ),
                          };
                        });
                      }}
                    />

                    <label
                      className="communication-label"
                      htmlFor={`index_${index}`}
                    >
                      {item.title}
                    </label>
                  </div>
                ))}
              </div>

              {/* <ErrorComponent
                title="Please select preferred communication mode  "
                flag={errorFlag}
                isArray={true}
                data={additionalInfo?.preferred_communication_mode}
              /> */}
            </div>
            <div className="mb-2 w-100">
              <RequiredLabel isRequired={false}>
                Top Keywords for Matchmaking (Max 5)
              </RequiredLabel>
              <InfoIconForKeyword />

              <TagsInput
                inputProps={{
                  placeholder: "Please hit ENTER to save keyword",
                  className: isWarning(fields_to_improve, "top_keywords")
                    ? "warning-field form-control react-tagsinput-input "
                    : "form-control react-tagsinput-input ",
                }}
                value={
                  additionalInfo?.top_keywords?.length > 0
                    ? additionalInfo?.top_keywords?.map(
                      (ele: any) => ele?.title,
                    )
                    : []
                }
                preventSubmit
                addOnPaste
                onlyUnique
                onChange={(tags: string[]) => {
                  if (tags?.length > 5) {
                    toast.warn("Max 5 keywords allowed!");
                    return;
                  }
                  setAdditionalInfo(
                    (prev: AdditionalInfoWantToGrowInterfaceNEW) => ({
                      ...prev,
                      top_keywords: tags.map((tag) => ({ title: tag })),
                    }),
                  );
                }}
              />
              {/* <ErrorComponent
                title="Please enter at least one keyword"
                flag={errorFlag}
                isArray={true}
                data={additionalInfo?.top_keywords}
              /> */}
            </div>
            <div className="mb-2">
              <RequiredLabel isRequired={false}>
                Are You Also Seeking Any Specific Solutions or Partners?
              </RequiredLabel>

              <div className="d-flex gap-3 mt-1">
                <div className="form-check">
                  <input
                    className={`form-check warning-radio-wrapper ${isWarning(
                      fields_to_improve,
                      "seeking_any_solution_partner",
                    )
                      ? "active-warning"
                      : ""
                      }`}
                    type="radio"
                    name="seeking_any_solution_partner"
                    id="yes"
                    value="1"
                    checked={
                      additionalInfo?.seeking_any_solution_partner === "1" ||
                      additionalInfo?.seeking_any_solution_partner === 1
                    }
                    onChange={(e) =>
                      setAdditionalInfo(
                        (pre: AdditionalInfoWantToGrowInterfaceNEW) => ({
                          ...pre,
                          seeking_any_solution_partner: "1",
                        }),
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="yes">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className={`form-check warning-radio-wrapper ${isWarning(
                      fields_to_improve,
                      "seeking_any_solution_partner",
                    )
                      ? "active-warning"
                      : ""
                      }`}
                    type="radio"
                    name="seeking_any_solution_partner"
                    id="no"
                    value="0"
                    checked={
                      additionalInfo?.seeking_any_solution_partner === "0" ||
                      additionalInfo?.seeking_any_solution_partner === 0
                    }
                    onChange={(e) =>
                      setAdditionalInfo(
                        (pre: AdditionalInfoWantToGrowInterfaceNEW) => ({
                          ...pre,
                          solution_requirement: "",
                          seeking_any_solution_partner: "0",
                        }),
                      )
                    }
                  />
                  <label className="form-check-label" htmlFor="no">
                    No
                  </label>
                </div>
              </div>
              {/* <ErrorComponent
                title="Please select seeking for solution partner"
                flag={errorFlag}
                isArray={false}
                data={additionalInfo?.seeking_any_solution_partner}
              /> */}
            </div>
            {additionalInfo?.seeking_any_solution_partner === "1" && (
              <div className="w-100 mb-2">
                <RequiredLabel isRequired={true}>
                  Mention Solution Requirement Brief
                </RequiredLabel>

                <Form.Control
                  as="textarea"
                  maxLength={700}
                  placeholder="Solution requirment"
                  name="solution_requirement"
                  value={additionalInfo?.solution_requirement}
                  onChange={handleChange}
                  className={
                    isWarning(fields_to_improve, "solution_requirement")
                      ? "warning-field"
                      : ""
                  }
                />
                {errorFlag &&
                  !additionalInfo?.solution_requirement &&
                  additionalInfo?.seeking_any_solution_partner === "1" && (
                    <Label
                      title="Please enter solution requirment in brief"
                      modeError={true}
                    />
                  )}
              </div>
            )}
            {!(
              from === "REVIEW" ||
              (typeof window !== "undefined" &&
                (window.location.href.includes("/my-profile") ||
                  window.location.href.includes("/profile-review")))
            ) && (
                <div className="mb-3 mt-2">
                  <div className="d-flex justify-content-between">
                    <div>
                      <RequiredLabel isRequired={false}>
                        Brief About Your Business
                      </RequiredLabel>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "2px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "40x",
                          fontWeight: "bold",
                        }}
                      >
                        <p className="font-10 font-bold" style={{ margin: 0 }}>
                          {additionalInfo?.brief_about_business?.length || 0}/700
                        </p>
                      </div>
                    </div>
                  </div>

                  <Form.Control
                    as="textarea"
                    className={
                      isWarning(fields_to_improve, "brief_about_business")
                        ? "warning-field"
                        : ""
                    }
                    placeholder={t("Register.enter_description")}
                    style={{ height: "80px" }}
                    name="brief_about_business"
                    maxLength={700}
                    value={additionalInfo?.brief_about_business}
                    onChange={handleChange}
                  />
                </div>
              )}
            <div>
              <RequiredLabel isRequired={false}>
                Highlight Top 3 Products / Services (Optional)
              </RequiredLabel>

              {additionalInfo?.products?.map(
                (item: ProductsDescriptionWantToGrow, index: number) => (
                  <Card
                    className="mb-3 shadow-sm"
                    key={index}
                  >
                    <Card.Body>
                      <div className="d-flex align-items-center gap-2 ms-auto justify-content-end mb-2">
                        {index === 0 &&
                          additionalInfo.products.length < MAX_PRODUCTS && (
                            <div
                              onClick={handleAdd}
                              style={{ cursor: "pointer" }}
                              title="Add product"
                            >
                              <FaPlus size={18} color="green" />
                            </div>
                          )}
                        {additionalInfo.products.length > 1 ? (
                          <div
                            onClick={() => handleDelete(index)}
                            style={{ cursor: "pointer" }}
                            title="Delete product"
                          >
                            <AiOutlineClose size={18} color="red" />
                          </div>
                        ) : isProductStarted(item) ? (
                          <button
                            type="button"
                            onClick={() => handleDelete(index)}
                            className="btn btn-sm btn-outline-secondary font-11 py-0 px-2"
                            title="Clear product fields"
                          >
                            Clear
                          </button>
                        ) : null}
                      </div>

                      <Row className="g-2">
                        <Col md={6}>
                          <Form.Control
                            type="text"
                            placeholder={isProductStarted(item) ? "Title *" : "Title"}
                            name="title"
                            value={item?.title || ""}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>,
                            ) => handleProductChange(index, e)}
                          />
                          {errorFlag && isProductStarted(item) && !item?.title?.trim() && (
                            <Label title="Please enter title" modeError={true} />
                          )}
                        </Col>
                        <Col md={6}>
                          <Form.Control
                            type="text"
                            placeholder={isProductStarted(item) ? "Category *" : "Category"}
                            name="category"
                            value={item?.category || ""}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>,
                            ) => handleProductChange(index, e)}
                          />
                          {errorFlag && isProductStarted(item) && !item?.category?.trim() && (
                            <Label title="Please enter category" modeError={true} />
                          )}
                        </Col>
                      </Row>

                      <Row className="g-2 mt-2">
                        <Col md={12}>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            placeholder="Description"
                            name="description"
                            value={item?.description || ""}
                            onChange={(
                              e: React.ChangeEvent<HTMLTextAreaElement>,
                            ) => handleProductChange(index, e)}
                          />
                        </Col>
                      </Row>

                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="font-11 text-muted">
                          {isProductStarted(item) ? (
                            <span><span className="text-danger">*</span> Product image is required</span>
                          ) : (
                            <span>Product image</span>
                          )}
                        </div>
                        {!item?.image && !item?.image_url ? (
                          <div
                            className="text-success text-end"
                            style={{ cursor: "pointer" }}
                          >
                            {imageLaoder[index] ? (
                              <Spinner size="sm" color="green" />
                            ) : (
                              <label
                                htmlFor={`prod-img-${index}`}
                                style={{ cursor: "pointer" }}
                                className="d-flex align-items-center gap-1 fw-semibold font-12 px-2 py-1 rounded border border-success text-success"
                              >
                                <FaUpload
                                  size={14}
                                  color="green"
                                  className="me-1"
                                />
                                Upload Image
                              </label>
                            )}

                            <Form.Control
                              type="file"
                              className="opacity-0 d-none"
                              name={`prod-img-${index}`}
                              onChange={(e) => uploadFile(e, index)}
                              accept="image/*"
                              id={`prod-img-${index}`}
                            />
                          </div>
                        ) : (
                          <div className="d-flex justify-content-end gap-2 align-items-center">
                            <div
                              className="text-success text-end"
                              style={{ cursor: "pointer" }}
                            >
                              {imageLaoder[index] ? (
                                <Spinner size="sm" color="green" />
                              ) : (
                                <label
                                  htmlFor={`prod-img-${index}`}
                                  style={{ cursor: "pointer" }}
                                  className="d-flex align-items-center gap-1 fw-semibold font-12 px-2 py-1 rounded border border-success text-success"
                                >
                                  <FaUpload
                                    size={14}
                                    color="green"
                                    className="me-1"
                                  />
                                  Change Image
                                </label>
                              )}

                              <Form.Control
                                type="file"
                                className="opacity-0 d-none"
                                name={`prod-img-${index}`}
                                onChange={(e) => uploadFile(e, index)}
                                accept="image/*"
                                id={`prod-img-${index}`}
                              />
                            </div>
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              onClick={() =>
                                handleImageView(item?.image_url, item?.image)
                              }
                            >
                              View
                            </Button>
                          </div>
                        )}
                      </div>
                      {errorFlag && isProductStarted(item) && !item?.image && !item?.image_url && (
                        <div className="text-end mt-1">
                          <Label title="Please upload product image" modeError={true} />
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                ),
              )}
              {errorFlag &&
                additionalInfo?.products?.some(
                  (p) => isProductStarted(p) && !isProductComplete(p),
                ) && (
                  <Label
                    title="Please complete all required fields (Title, Category, Image) for any started product"
                    modeError={true}
                  />
                )}
            </div>

            <div className="mb-2 d-flex gap-2">
              <Button
                className={
                  from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"
                    ? "btn btn-primary w-100"
                    : "btn btn-primary w-50"
                }
                type="button"
                id="save_basic_details"
                onClick={() => {
                  setSkipButtonClicked(false);
                  handleSaveAdditionInfo(false);
                }}
                disabled={apiCallTriggered}
              >
                {" "}
                {from && from === "REVIEW"
                  ? t("Register.save")
                  : t("Register.continue")}
              </Button>
              {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
                <Button
                  className="btn btn-secondary w-50"
                  type="button"
                  id="skip_basic_details"
                  disabled={apiCallTriggered}
                  onClick={() => {
                    setSkipButtonClicked(true);
                    handleSaveAdditionInfo(true);
                  }}
                >
                  Skip
                </Button>
              )}
            </div>
          </div>
        </div>
      </CommonScrollbar>
      {modalImage && (
        <CommonModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          title="Product Image"
          url={modalImage}
          fileTitle={modalTitle}
        />
      )}
    </div>
  </>
  );
};

export default AdditionalInfoWantToGrow;
